export default function ComponentBlocksText ({ Content }) {
  return (
    <div className="col-12">
      <div dangerouslySetInnerHTML={{ __html: Content }}></div>
    </div>
  )
}
